import { useMutation } from 'react-query';

import { firstAccess } from '..';

export const useFirstAccess = () => {
  return useMutation(['first', 'login'], firstAccess);
};
